import Vue from 'vue';
import App from './App.vue';
import store  from './store';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import router from './router';
import axios from 'axios'
import VueSilentbox from 'vue-silentbox';
Vue.use(VueSilentbox)
import FlashMessage from '@smartweb/vue-flash-message';
Vue.use(FlashMessage)
import _ from 'lodash';
Vue.prototype._ = _
if (localStorage.getItem("session_id") === null) {
  localStorage.setItem('session_id', new Date().valueOf() + '' + Math.random().toString(36).substr(2, 6));
}

import titleMixin from '../titleMixin';
Vue.mixin(titleMixin);

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing)

import helper from './helper/utils';
Vue.use({
  install() {
      Vue.helper = helper;
      Vue.prototype.$helper = helper;
  }
});

const base = axios.create({
  baseURL: process.env.VUE_APP_APIURL,
})
Vue.prototype.$http = base

const auth = axios.create({
  baseURL: process.env.VUE_APP_APIURL,
  headers: {
      'Authorization': 'Bearer '+localStorage.getItem('token'),
  }
})
Vue.prototype.$authHttp = auth

// Deal with all responses containing a 401 error to try to refresh the access token if possible
auth.interceptors.response.use(
  // No special handling of responses needed. We return it as it comes in.
  response => {
    return response;
  },
  // This object is not null if an error occured
  error => {
    // Check if it is a 401 Unauthorized error
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("name");
      localStorage.removeItem("mobile");
      localStorage.removeItem("email");
      window.location.href = '/login';
    }
    // No special treatement of any other error
    return Promise.reject(error);
  }
);

// Clear old localStorage cart data (no longer used — cart is now in database)
localStorage.removeItem("cart");

Vue.config.productionTip = false;
Vue.DOMAIN = Vue.prototype.APIURL = process.env.VUE_APP_DOMAIN;
Vue.APIURL = Vue.prototype.APIURL = process.env.VUE_APP_APIURL;
Vue.IMAGEURL = Vue.prototype.IMAGEURL = process.env.VUE_APP_IMAGEURL;
Vue.baseUrl = Vue.prototype.baseUrl = process.env.VUE_APP_BASEURL;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount(`#app`);
